<div>
  <iframe
    wlCSMask
    class="d-block border-0 w-100"
    [src]="mapUrl | safe: 'resourceUrl'"
  ></iframe>
  <div class="legend pt-2">
    <div class="d-flex justify-content-between mb-1">
      <span *scText="fields?.MapLegendBadSun"></span>
      <span *scText="fields?.MapLegendGoodSun"></span>
    </div>
    <div class="gradient-bar"></div>
  </div>
</div>
